import { useEffect, useState } from 'react';

/**
 * Debounce de um valor reativo. Usado em filtros de busca pra evitar
 * spam de requisicoes a cada keystroke.
 *
 * Pattern padrao para listagens server-side (Monitoramento, Cartoes
 * Temporarios, Faturas). Default 300ms.
 */
export function useDebounce<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
